import React from 'react';
import PropTypes from 'prop-types';

import get from 'lodash/get';

import Bone from '@lightspeed/cirrus-bone';
import Card, { CardSection } from '@lightspeed/cirrus-card';
import Text from '@lightspeed/cirrus-text';

import GatewayConfig from '../index';
import { supportedTerminalsForGateway } from './utils';

const iconSize = '1.125rem';

const STRINGS = {
  NO_GATEWAY: { MESSAGE: 'You have no shops authorized at the moment.' },
};

const Skeleton = () => (
  <Card large>
    <CardSection>
      <div className="cr-flex cr-flex-wrap">
        <div className="cr-flex cr-width-full">
          <div className="cr-flex cr-width-full cr-flex-col">
            <div className="cr-flex cr-width-full cr-items-center">
              <div className="cr-mr-2 cr-width-full" style={{ width: iconSize }}>
                <Bone width={iconSize} height={iconSize} />
              </div>
              <Bone width="35%" height="1.125rem" />
            </div>
            <div className="cr-flex cr-width-full cr-items-center cr-mt-2">
              <div className="cr-mr-2" style={{ minWidth: iconSize, height: iconSize }} />
              <div className="cr-width-full">
                <div className="cr-mb-2 cr-width-full">
                  <Bone height="0.8rem" />
                </div>
                <div className="cr-width-full">
                  <Bone height="0.8rem" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </CardSection>
  </Card>
);

const Empty = () => (
  <Card large>
    <CardSection>
      <div className="cr-flex cr-width-full cr-items-center">
        <Text bodySmall dimmed>
          {STRINGS.NO_GATEWAY.MESSAGE}
        </Text>
      </div>
    </CardSection>
  </Card>
);

const GatewayConfigListing = ({ gatewayConfigs, shops, isLoading }) => {
  if (isLoading) {
    return <Skeleton />;
  }
  if (gatewayConfigs && gatewayConfigs.length > 0) {
    return gatewayConfigs.map(gatewayConfig => {
      const { locationAddress, authorizedShops } = get(gatewayConfig, 'parameters', {
        locationAddress: '',
        authorizedShops: {},
      });
      const gatewayConfigID = get(gatewayConfig, 'gatewayConfigID');

      return (
        <GatewayConfig
          key={gatewayConfigID}
          address={locationAddress && JSON.parse(locationAddress)}
          authorizedShops={authorizedShops}
          gatewayConfigID={gatewayConfigID}
          supportedTerminalTypes={supportedTerminalsForGateway(gatewayConfig)}
          shops={shops}
        />
      );
    });
  }
  return <Empty />;
};

const gatewayConfigShape = PropTypes.shape({
  gatewayConfigID: PropTypes.string,
  name: PropTypes.string,
  gatewayID: PropTypes.string,
  allowNegativePayments: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  cardSchemeMappings: PropTypes.any.object,
  // eslint-disable-next-line react/forbid-prop-types
  parameters: PropTypes.any.object,
});

GatewayConfigListing.propTypes = {
  gatewayConfigs: PropTypes.arrayOf(gatewayConfigShape),
  shops: PropTypes.func,
  isLoading: PropTypes.bool,
};

GatewayConfigListing.defaultProps = {
  isLoading: true,
};

export default GatewayConfigListing;
